import React, { useState } from 'react';
import axios from 'axios';
import {
    Card,
    Input,
    Checkbox,
    Button,
    Typography,
} from "@material-tailwind/react";


export function SignIn() {
    // const imageUrl = document.getElementById('login-imagebg').dataset.imageUrl;
    const imageUrl = '';


    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    function getCsrfToken() {
        const token = document.querySelector('meta[name="csrf-token"]');
        return token ? token.content : null;
    }

    const csrfToken = getCsrfToken();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const response = await axios.post('login', {
                user: {username, password},
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            });

            if (response.status === 200) {
                window.location.href = '/dashboard';
            }
        } catch (err) {
            setError('Error al iniciar sesión. Verifica tus credenciales.');
        }
    };

    return (
        <section className="m-8 flex gap-4 w-full min-h-screen-75">
            <div className="w-2/5 min-h-screen pb-20 relative hidden lg:block overflow-hidden">
                <img
                    src={imageUrl}
                    className="h-full w-full object-cover rounded-3xl"
                    style={{objectFit: "cover"}}
                />
                <div
                    className="absolute transform bg-white/50 bg-opacity-50 p-4 shadow-lg transition-all duration-300 ease-in-out"
                    style={{height: '100%', width: '100%', top: 0}}>

                    <div id="react-root" data-logo-path="<%= asset_path('logo_ginther_corp_n.png') %>"></div>

                    <img
                        src=""
                        className="absolute left-1/2 transform -translate-x-1/2 top-210-px w-3/4"
                    />
                </div>
            </div>


            <div className="w-full lg:w-3/5 mt-24">
            <div className="text-center">
                    <Typography variant="h2" className="font-bold mb-4">Iniciar sesión</Typography>
                    <Typography variant="paragraph" color="blue-gray" className="text-lg font-normal">Ingresa tu usuario
                        y contraseña para Iniciar Sesión.</Typography>
                </div>
                <form className="mt-8 mb-2 mx-auto w-80 max-w-screen-lg lg:w-1/2">
                    <div className="mb-1 flex flex-col gap-6">
                        <Typography variant="small" color="blue-gray" className="-mb-3 font-medium">
                            Usuario
                        </Typography>
                        <Input
                            size="lg"
                            placeholder="usuario"
                            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                            labelProps={{
                                className: "before:content-none after:content-none",
                            }}
                            onChange={(e) => setUsername(e.target.value)}
                            value={username}
                        />
                        <Typography variant="small" color="blue-gray" className="-mb-3 font-medium">
                            Contraseña
                        </Typography>
                        <Input
                            type="password"
                            size="lg"
                            placeholder="********"
                            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                            labelProps={{
                                className: "before:content-none after:content-none",
                            }}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                    <Button className="mt-6" fullWidth onClick={handleLogin}>
                        Iniciar Sesión
                    </Button>

                    <div className="flex items-center justify-center gap-2 mt-6">
                        <Typography variant="small" className="font-medium text-gray-900">
                            <a href="#">
                                Olvidé mi contraseña
                            </a>
                        </Typography>
                    </div>
                </form>

            </div>

        </section>
    );
}

export default SignIn;
